import React from "react";
import Prismic from "prismic-javascript";
import NotFound from "./NotFound";
import Loader from "./Loader";
import ProjectItem from "./ProjectItem";

export default class Projects extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notFound: false,
      list: []
    };
    if (props.prismicCtx) {
      this.fetchList(props);
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.prismicCtx) {
      this.fetchList(this.props);
    }
  }

  fetchList(props) {
    return props.prismicCtx.api
      .query(Prismic.Predicates.at("document.type", "projects"))
      .then(res => {
        const list = res.results.sort((a, b) => {
          return a.data.order - b.data.order;
        });
        this.setState({ list });
      });
  }

  listSection() {
    return (
      <div className="row">
        {this.state.list.map((item, index) => {
          return (
            <div className="col-12 col-md-4 mb-3" key={index}>
              <ProjectItem prismicCtx={this.props.prismicCtx} item={item} />
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    if (this.state.list.length > 0) {
      return <div>{this.listSection()}</div>;
    } else if (this.state.notFound) {
      return <NotFound />;
    }
    return <Loader />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects.js